


import Vue from 'vue';
import {Location} from "vue-router";
import {localizedRoute} from "@/i18n/i18n.config";
import {RouteName} from "@/router";

export default Vue.extend({
    computed: {
        offerRoute(): Location {
            return localizedRoute(RouteName.offerList);
        }
    }
});
